import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/css/css';

import { Component, Inject, NgZone, OnInit, Renderer2, DOCUMENT } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { map, switchMap, tap, filter } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { SignInService } from './common/services/sign-in/sign-in.service';

import { CohortDO } from './common/domain-model-dtos';
import { AdminContextService } from './common/services/admin.context.service';
import { LottoUser } from './components/views/sign-in/user.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  private static readonly FIXED_COHORT_ID = 1;

  public loading = true;

  theme: Observable<string>;

  constructor(
    private router: Router,
    private singInService: SignInService,
    private ngZone: NgZone,
    private activatedRoute: ActivatedRoute,
    private adminContextService: AdminContextService,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2
  ) {}

  private currentCohort: CohortDO;

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.appendCohortIdQueryParam(event.url);
      }
    });

    this.singInService.initiatedUser
      .pipe(
        filter((d) => !!d),
        map(() => this.singInService.getCurrentUser()),
        filter((user) => user !== null && user.isSignedIn()),
        switchMap((user: LottoUser) => this.singInService.signInToApp(user.getToken()))
      )
      .subscribe(() => this.onAuthSuccess());

    this.adminContextService
      .getCohortWatcher()
      .pipe(
        filter((c) => !!c),
        filter((p) => !this.currentCohort || this.currentCohort.id !== p.id)
      )
      .subscribe((c) => {
        this.currentCohort = c;
        this.changeCohortIdQueryParam();
      });
  }

  private appendCohortIdQueryParam(url: string) {
    const parsedUrl = this.router.parseUrl(url);
    if (parsedUrl.queryParams['cohortId'] != AppComponent.FIXED_COHORT_ID) {
      parsedUrl.queryParams = {
        ...parsedUrl.queryParams,
        cohortId: AppComponent.FIXED_COHORT_ID,
      };
      this.router.navigateByUrl(parsedUrl);
    }
  }

  private changeCohortIdQueryParam() {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { cohortId: AppComponent.FIXED_COHORT_ID },
      queryParamsHandling: 'merge',
    });
  }

  private onAuthSuccess() {
    this.ngZone.run(() => {
      this.loading = false;
    });
  }
}
